import React from 'react';
import PropTypes from 'prop-types';
import { H3, Paragraph } from 'components/core/Typography';
import ReviewRating from 'components/review/Review/ReviewRating';
import { Link } from 'components/atoms';

import './PSPReview.scss';

export function PSPReview({ pageType = "PSP", ...props }) {
	return (
		<Link className="review-card" href={props?.link} target="_blank" hideBorder>
	
				<div className="title-section">
					<H3
						className="review-title"
						size="medium"
					>
						{props.reviewTitle}
					</H3>
					<ReviewRating
						reviewRating={props.reviewRating}
						reviewRatingOutOf={5}
					/>
				</div>
				<Paragraph
					className="sf-type-black review-text"
					weight="standard"
				>
					{props.reviewText}
				</Paragraph>
				<Paragraph
					className={`reviewer ${pageType.toLowerCase()}`}
					last
				>
					{props.reviewerImage ? (
						<img
							src={
								typeof props.reviewerImage === 'string'
									? props.reviewerImage
									: props.reviewerImage.src
							}
							alt={props.reviewerName}
							className="reviewer-image"
						/>
					):
					props.reviewerInitials && (
						<span className="initials sf-type-weight-bold">
							{props.reviewerInitials}
						</span>
					)}
					<span className="sf-type-weight-bold">
						{' '}
						by {props.reviewerName}{' '}
					</span>
					{props.reviewDate && (
						<span className="review-date sf-type-weight-standard">
							on {props.reviewDate}
						</span>
					)}
				</Paragraph>
		
		</Link>
	);
}

PSPReview.propTypes = {
	reviewerName: PropTypes.string,
	reviewTitle: PropTypes.string,
	reviewText: PropTypes.string,
	reviewRating: PropTypes.number,
	reviewerInitials: PropTypes.string,
	reviewerImage: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
		.isRequired,
	reviewDate: PropTypes.string,
	link: PropTypes.string,
	pageType: PropTypes.string,
};

export default PSPReview;
